import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

interface Props {
  path: string;
}

const Header: React.FC<Props> = props => {
  const { path } = props;

  const [navVisible, setNavVisible] = useState(false);

  return (
    <header
      className={`
      global-header ${path === '/contact' ? 'contact' : ''}
      `}
    >
      <div className="content">
        <a href="http://lanxiongsports.com/">
          <img
            src={
              path === '/contact'
                ? 'http://imgcdn.lanxiongsports.com/uploads/2019/09/17/1568730041.png'
                : 'http://imgcdn.lanxiongsports.com/upload/topic/lx_logo.png'
            }
            alt="懒熊体育"
            className="logo"
          />
        </a>
        <ul className="nav">
          <li className={`${path === '/' ? 'active' : ''}`}>
            <Link to="/">关于懒熊</Link>
          </li>
          <li className={`${path === '/jobs' ? 'active' : ''}`}>
            <Link to="/jobs">加入我们</Link>
          </li>
          <li className={`${path === '/contact' ? 'active' : ''}`}>
            <Link to="/contact">联系我们</Link>
          </li>
          <li className={`${path === '/en' ? 'active' : ''}`}>
            <Link to="/en">About</Link>
          </li>
        </ul>
        <div className="m-nav">
          <div
            className="nav-icon"
            onClick={() => {
              setNavVisible(!navVisible);
            }}
          >
            <i></i>
            <i></i>
            <i></i>
          </div>
          <ul className={`m-nav-list ${navVisible ? 'list-show' : ''}`}>
            <li
              onClick={() => {
                setNavVisible(false);
              }}
            >
              <Link to="/">关于懒熊</Link>
            </li>
            <li
              onClick={() => {
                setNavVisible(false);
              }}
            >
              <Link to="/jobs">加入我们</Link>
            </li>
            <li
              onClick={() => {
                setNavVisible(false);
              }}
            >
              <Link to="/contact">联系我们</Link>
            </li>
            <li
              onClick={() => {
                setNavVisible(false);
              }}
            >
              <Link to="/en">About</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
